// ============================================================================
// YENİ BİLEŞEN NASIL EKLENİR? (bkz. docs/mimic-screen-component-ekleme.md)
// ============================================================================
// Her palette öğesi şu alanlara sahip bir obje. Kod tarafında (FlowComponent.js
// / ToolboxPanel.js) HİÇBİR DEĞİŞİKLİK GEREKMEZ — sadece bu diziye obje eklemek
// yeterli. Runtime seçim mantığı FlowComponent.js > getImagePathByToolboxId().
//
//   id         : Zorunlu, bu dosyadaki TÜM girdiler arasında BENZERSİZ string.
//                Şu an en yüksek id ~770; 800+ kullanmak güvenli. Aynı id iki
//                yerde geçerse ikincisi asla eşleşmez.
//
//   groupid    : Zorunlu. Aynı FİZİKSEL bileşenin farklı görsel DURUMLARINI
//                (renk/aralık varyantlarını) birbirine bağlayan anahtar.
//                - Tek durumlu (statik) bir ikon istiyorsan: kendine özel,
//                  BAŞKA HİÇBİR ÖĞEYLE PAYLAŞILMAYAN yeni bir groupid ver.
//                - Değere göre görsel değiştirmesini istiyorsan (ör. vana
//                  açık/kapalı, basınç yeşil/sarı/kırmızı): aynı groupid'i
//                  taşıyan 2-4 obje ekle (aşağıdaki colourType / minValue
//                  bölümüne bak). Runtime, tag değerine bakıp bu gruptan
//                  DOĞRU görseli otomatik seçer.
//
//   type       : Serbest metin, bileşenin adı/etiketi (palette'te ve
//                canvas'ta görünür — bkz. name). Aynı groupid'teki tüm
//                varyantlarda genelde AYNI type kullanılır.
//
//   name       : Opsiyonel. Verilirse palette'te type yerine bunu gösterir
//                (ToolboxPanel.js: item.name || item.type). Bu dosyadaki
//                girişler name yerine doğrudan type'ı okunaklı tuttu, o
//                yüzden name alanı çoğunlukla atlanmış — istersen ekleyebilirsin.
//
//   imagePath  : Zorunlu. Ya `/images/dosya.png` (public/images/ altında
//                gerçek bir dosya — büyük/küçük harf duyarlı!) ya da
//                `data:image/svg+xml;...` inline SVG data-URI (dosya
//                gerektirmez, bu dosyadaki svg()/GAUGE()/THERMO() gibi
//                helper'lar tam da bunu üretiyor — aşağıya bak).
//
//   colourType : Zorunlu string ('0','1','2',...). Üç farklı şekilde
//                yorumlanır (FlowComponent.js hangi moda gireceğine göre
//                otomatik karar verir):
//                a) GRUPTA minValue/maxValue YOKSA → "tam eşleşme": tag
//                   değeri sayıya çevrilir ve parseInt(colourType) === değer
//                   olan öğe gösterilir. Örn. bir vana tag'i 0/1/2 dönüyorsa
//                   colourType '0'/'1'/'2' olan 3 ayrı obje eklersin (bkz.
//                   aşağıdaki "Ball Valve" örneği). Eşleşme yoksa colourType
//                   '0' olana (yoksa gruptaki ilk öğeye) düşer.
//                b) GRUPTA minValue/maxValue VARSA → colourType görüntüde
//                   önemsizdir (aşağıya bak), sadece okunabilirlik/sıra
//                   için 0,1,2... verilir.
//                c) groupid, FlowComponent.js'teki GROUPS_WITH_TWO_BITS
//                   listesindeyse → iki ayrı tag'in (0/1) bit kombinasyonuna
//                   göre 0-4 arası özel bir colourType hesaplanır. Bu dosyada
//                   yeni bir grubu bu listeye EKLEMEDİK (kod değişikliği
//                   gerektirir) — bunu kullanmak istersen kod tarafına
//                   dokunman gerekir, aksi halde bu maddeyi yok say.
//
//   minValue,  : Opsiyonel — İKİSİ DE VARSA aralık-tabanlı (Yöntem 3b) devreye
//   maxValue     girer: tag değeri [minValue, maxValue] aralığına düşen ilk
//                obje gösterilir (dahil aralık, >= ve <=). Sürekli/analog
//                değerler (basınç, sıcaklık, debi, gaz %) için kullanılır —
//                aşağıdaki GAUGE/THERMO/FLOW/HAZARD gruplarına bak. Kurallar:
//                - Aynı groupid altındaki TÜM objelere minValue/maxValue
//                  vermelisin (biri eksikse o obje eşleşme dışı kalır ama
//                  grup yine de "range modunda" sayılır — karışıklığı
//                  önlemek için hepsine ver).
//                - Aralıklar BİRBİRİNE BİTİŞİK ve boşluksuz olmalı (üstteki
//                  aralığın min'i alttakinin max'ından hemen sonra gelsin,
//                  ör. 0–8, 8.01–12, 12.01–9999) — aksi halde ara değerlerde
//                  hiçbir görsel eşleşmez ve view:'1' olan varsayılana düşer.
//                - En üst bandın maxValue'sunu güvenli bir üst sınır yap
//                  (ör. 9999) ki tag beklenmedik yüksek bir değer okursa yine
//                  "kırmızı/kritik" görünsün.
//                - Bu satırdaki sayılar DEMO VARSAYILANI: gerçek sahaya
//                  koymadan önce müşterinin gerçek eşiklerine göre değiştir.
//
//   view       : Zorunlu string '1' veya '0'.
//                - '1'  → bu obje PALETTE'te (sürükle-bırak listesinde)
//                  görünür ve canvas'a ilk sürüklendiğinde gösterilecek
//                  VARSAYILAN/başlangıç görselidir.
//                - '0'  → palette'te GÖRÜNMEZ; sadece runtime'da (canlı tag
//                  değeri geldiğinde) otomatik gösterilen bir "durum
//                  varyantı"dır, kullanıcı bunu elle sürükleyemez.
//                KURAL: aynı groupid içinde SADECE BİR obje view:'1' olmalı
//                (genelde en "normal/güvenli" durum — yeşil, kapalı, vs.).
//                İkiden fazla view:'1' aynı grupta olursa palette'te aynı
//                bileşen mükerrer görünür.
//
// ÖRNEK 1 — Statik (durum değişmeyen) yeni ikon:
//   { groupid: '800', id: '800', type: 'My Sensor', imagePath: '/images/my_sensor.png', colourType: '0', view: '1' },
//
// ÖRNEK 2 — Değere göre renk değiştiren (0/1/2 tam eşleşme):
//   { groupid: '801', id: '801', type: 'My Valve', imagePath: '/images/valve_green.png', colourType: '0', view: '1' },
//   { groupid: '801', id: '802', type: 'My Valve', imagePath: '/images/valve_red.png',   colourType: '1', view: '0' },
//
// ÖRNEK 3 — Analog değere göre eşik/aralık (yeşil/sarı/kırmızı):
//   { groupid: '803', id: '803', type: 'My Gauge', imagePath: GAUGE(GREEN),  colourType: '0', minValue: 0,    maxValue: 50,   view: '1' },
//   { groupid: '803', id: '804', type: 'My Gauge', imagePath: GAUGE(YELLOW), colourType: '1', minValue: 50.01, maxValue: 80,  view: '0' },
//   { groupid: '803', id: '805', type: 'My Gauge', imagePath: GAUGE(RED),    colourType: '2', minValue: 80.01, maxValue: 9999, view: '0' },
//
// Aşağıdaki yardımcı fonksiyonlar asset dosyası gerektirmeyen inline SVG
// üretir (Method 2) — çünkü bazı sensör/ekipman şekilleri için diskte hazır
// PNG yoktu. hex parametresi '#' OLMADAN RRGGBB (ör. '2ecc71') verilir; '#'
// karakteri fonksiyon içinde otomatik %23'e çevriliyor. Kendi rengini eklemek
// istersen GREEN/YELLOW/RED gibi yeni bir const tanımlayıp aynı fonksiyonlara ver.
const svg = (body) => `data:image/svg+xml;charset=UTF-8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 96">${body}</svg>`;
const GAUGE = hex => svg(`<circle cx="48" cy="48" r="36" fill="%23${hex}" stroke="black" stroke-width="4"/><line x1="48" y1="48" x2="70" y2="28" stroke="black" stroke-width="4" stroke-linecap="round"/><circle cx="48" cy="48" r="6" fill="black"/>`);
const THERMO = hex => svg(`<rect x="40" y="8" width="16" height="52" rx="8" fill="white" stroke="black" stroke-width="4"/><rect x="44" y="24" width="8" height="40" fill="%23${hex}"/><circle cx="48" cy="72" r="18" fill="%23${hex}" stroke="black" stroke-width="4"/>`);
const FLOW = hex => svg(`<rect x="6" y="34" width="84" height="28" rx="6" fill="%23${hex}" stroke="black" stroke-width="4"/><path d="M52 34 L78 48 L52 62 Z" fill="black"/>`);
const HAZARD = (hex, label) => svg(`<polygon points="48,6 90,48 48,90 6,48" fill="%23${hex}" stroke="black" stroke-width="4"/><text x="48" y="57" font-size="20" font-family="Arial,sans-serif" font-weight="bold" text-anchor="middle" fill="black">${label}</text>`);
const GREEN = '2ecc71';
const YELLOW = 'f1c40f';
const RED = 'e74c3c';
const GRAY = '95a5a6';
const BLUE = '3498db';
const ORANGE = 'e67e22';
const PURPLE = '8e44ad';
const TEAL = '16a085';

// Sector-flagship icon shapes (Mining truck, Wind turbine, Server rack, Ship,
// Greenhouse, Rotary kiln, etc.) — hand-drawn inline SVG because no matching
// PNG exists on disk for these. Used by the 20-sector pack further below.
const PANEL = (hex, label) => svg(`<rect x="10" y="14" width="76" height="68" rx="6" fill="white" stroke="black" stroke-width="4"/><rect x="10" y="14" width="76" height="18" rx="6" fill="%23${hex}" stroke="black" stroke-width="4"/><text x="48" y="55" font-size="16" font-family="Arial,sans-serif" font-weight="bold" text-anchor="middle" fill="black">${label}</text>`);
const SUN = hex => svg(`<path d="M20 70 A28 28 0 0 1 76 70 Z" fill="%23${hex}" stroke="black" stroke-width="4"/><line x1="48" y1="14" x2="48" y2="26" stroke="black" stroke-width="4"/><line x1="20" y1="30" x2="28" y2="38" stroke="black" stroke-width="4"/><line x1="76" y1="30" x2="68" y2="38" stroke="black" stroke-width="4"/>`);
const TRANSFORMER = hex => svg(`<circle cx="34" cy="48" r="22" fill="none" stroke="black" stroke-width="4"/><circle cx="62" cy="48" r="22" fill="%23${hex}" stroke="black" stroke-width="4"/>`);
const BREAKER = hex => svg(`<rect x="30" y="14" width="36" height="68" rx="4" fill="white" stroke="black" stroke-width="4"/><line x1="48" y1="26" x2="48" y2="50" stroke="black" stroke-width="6" stroke-linecap="round"/><circle cx="48" cy="62" r="6" fill="%23${hex}"/>`);
const ELEVATOR = hex => svg(`<rect x="26" y="14" width="44" height="68" fill="%23${hex}" stroke="black" stroke-width="4"/><path d="M48 22 L40 34 L56 34 Z" fill="black"/><path d="M48 74 L40 62 L56 62 Z" fill="black"/>`);
const CARD = hex => svg(`<rect x="16" y="16" width="64" height="64" rx="6" fill="white" stroke="black" stroke-width="4"/><rect x="30" y="34" width="36" height="24" rx="3" fill="%23${hex}" stroke="black" stroke-width="3"/><line x1="30" y1="70" x2="66" y2="70" stroke="black" stroke-width="3"/>`);
const CHILLER = hex => svg(`<rect x="10" y="30" width="76" height="46" rx="4" fill="%23${hex}" stroke="black" stroke-width="4"/><line x1="22" y1="40" x2="22" y2="66" stroke="black" stroke-width="3"/><line x1="35" y1="40" x2="35" y2="66" stroke="black" stroke-width="3"/><line x1="48" y1="40" x2="48" y2="66" stroke="black" stroke-width="3"/><line x1="61" y1="40" x2="61" y2="66" stroke="black" stroke-width="3"/><line x1="74" y1="40" x2="74" y2="66" stroke="black" stroke-width="3"/>`);
const WELLHEAD = hex => svg(`<line x1="48" y1="20" x2="48" y2="88" stroke="black" stroke-width="6"/><rect x="30" y="30" width="36" height="14" fill="%23${hex}" stroke="black" stroke-width="4"/><rect x="34" y="50" width="28" height="12" fill="%23${hex}" stroke="black" stroke-width="4"/><circle cx="48" cy="16" r="6" fill="black"/>`);
const RACK = hex => svg(`<rect x="20" y="8" width="56" height="80" fill="%23${hex}" stroke="black" stroke-width="4"/><line x1="26" y1="20" x2="70" y2="20" stroke="black" stroke-width="3"/><line x1="26" y1="34" x2="70" y2="34" stroke="black" stroke-width="3"/><line x1="26" y1="48" x2="70" y2="48" stroke="black" stroke-width="3"/><line x1="26" y1="62" x2="70" y2="62" stroke="black" stroke-width="3"/><line x1="26" y1="76" x2="70" y2="76" stroke="black" stroke-width="3"/>`);
const BATTERY = hex => svg(`<rect x="16" y="30" width="56" height="40" rx="4" fill="%23${hex}" stroke="black" stroke-width="4"/><rect x="72" y="42" width="8" height="16" fill="black"/><line x1="34" y1="38" x2="34" y2="62" stroke="black" stroke-width="4"/><line x1="46" y1="34" x2="46" y2="66" stroke="black" stroke-width="4"/><line x1="58" y1="38" x2="58" y2="62" stroke="black" stroke-width="4"/>`);
const TURBINE = hex => svg(`<rect x="44" y="40" width="8" height="48" fill="%23${hex}" stroke="black" stroke-width="3"/><circle cx="48" cy="36" r="4" fill="black"/><line x1="48" y1="36" x2="48" y2="8" stroke="black" stroke-width="4" stroke-linecap="round"/><line x1="48" y1="36" x2="24" y2="52" stroke="black" stroke-width="4" stroke-linecap="round"/><line x1="48" y1="36" x2="72" y2="52" stroke="black" stroke-width="4" stroke-linecap="round"/>`);
const MAST = hex => svg(`<line x1="48" y1="10" x2="48" y2="88" stroke="black" stroke-width="4"/><line x1="30" y1="24" x2="66" y2="24" stroke="black" stroke-width="4"/><circle cx="30" cy="24" r="6" fill="%23${hex}" stroke="black" stroke-width="2"/><circle cx="66" cy="24" r="6" fill="%23${hex}" stroke="black" stroke-width="2"/><rect x="36" y="46" width="24" height="16" fill="%23${hex}" stroke="black" stroke-width="3"/>`);
const ROBOT = hex => svg(`<rect x="14" y="70" width="24" height="14" fill="%23${hex}" stroke="black" stroke-width="4"/><line x1="26" y1="70" x2="26" y2="46" stroke="black" stroke-width="6" stroke-linecap="round"/><line x1="26" y1="46" x2="58" y2="30" stroke="black" stroke-width="6" stroke-linecap="round"/><line x1="58" y1="30" x2="80" y2="42" stroke="black" stroke-width="6" stroke-linecap="round"/><circle cx="80" cy="42" r="5" fill="%23${hex}" stroke="black" stroke-width="3"/>`);
const AUTOCLAVE = hex => svg(`<rect x="14" y="24" width="68" height="48" rx="24" fill="%23${hex}" stroke="black" stroke-width="4"/><circle cx="48" cy="48" r="14" fill="white" stroke="black" stroke-width="4"/>`);
const TANK = hex => svg(`<rect x="24" y="20" width="48" height="56" fill="%23${hex}" stroke="black" stroke-width="4"/><ellipse cx="48" cy="20" rx="24" ry="8" fill="%23${hex}" stroke="black" stroke-width="4"/><ellipse cx="48" cy="76" rx="24" ry="8" fill="none" stroke="black" stroke-width="3"/>`);
const TRUCK = hex => svg(`<rect x="8" y="34" width="50" height="28" fill="%23${hex}" stroke="black" stroke-width="4"/><path d="M58 40 L80 40 L80 62 L58 62 Z" fill="%23${hex}" stroke="black" stroke-width="4"/><circle cx="24" cy="68" r="10" fill="black"/><circle cx="70" cy="68" r="10" fill="black"/>`);
const CONVEYOR = hex => svg(`<rect x="8" y="40" width="80" height="16" rx="8" fill="%23${hex}" stroke="black" stroke-width="4"/><circle cx="24" cy="70" r="10" fill="white" stroke="black" stroke-width="4"/><circle cx="72" cy="70" r="10" fill="white" stroke="black" stroke-width="4"/>`);
const CRUSHER = hex => svg(`<path d="M20 20 L76 20 L60 80 L36 80 Z" fill="%23${hex}" stroke="black" stroke-width="4"/><line x1="30" y1="36" x2="66" y2="36" stroke="black" stroke-width="2"/>`);
const GREENHOUSE = hex => svg(`<path d="M8 78 L8 48 Q48 8 88 48 L88 78 Z" fill="%23${hex}" stroke="black" stroke-width="4"/><line x1="8" y1="78" x2="88" y2="78" stroke="black" stroke-width="4"/><line x1="28" y1="60" x2="28" y2="78" stroke="black" stroke-width="2"/><line x1="48" y1="52" x2="48" y2="78" stroke="black" stroke-width="2"/><line x1="68" y1="60" x2="68" y2="78" stroke="black" stroke-width="2"/>`);
const SHIP = hex => svg(`<path d="M10 60 L86 60 L74 80 L22 80 Z" fill="%23${hex}" stroke="black" stroke-width="4"/><rect x="34" y="34" width="28" height="26" fill="%23${hex}" stroke="black" stroke-width="4"/><line x1="48" y1="18" x2="48" y2="34" stroke="black" stroke-width="4"/>`);
const CONTAINER = hex => svg(`<rect x="10" y="26" width="76" height="46" fill="%23${hex}" stroke="black" stroke-width="4"/><line x1="10" y1="38" x2="86" y2="38" stroke="black" stroke-width="2"/><line x1="10" y1="50" x2="86" y2="50" stroke="black" stroke-width="2"/><line x1="10" y1="62" x2="86" y2="62" stroke="black" stroke-width="2"/>`);
const DRUM = hex => svg(`<ellipse cx="20" cy="48" rx="10" ry="26" fill="%23${hex}" stroke="black" stroke-width="4"/><rect x="20" y="22" width="56" height="52" fill="%23${hex}" stroke="black" stroke-width="4"/><ellipse cx="76" cy="48" rx="10" ry="26" fill="%23${hex}" stroke="black" stroke-width="4"/><line x1="30" y1="30" x2="66" y2="30" stroke="black" stroke-width="2"/>`);
const FURNACE = hex => svg(`<rect x="28" y="24" width="40" height="60" fill="%23${hex}" stroke="black" stroke-width="4"/><rect x="20" y="8" width="16" height="20" fill="%23${hex}" stroke="black" stroke-width="3"/><path d="M48 60 Q40 48 48 36 Q56 48 48 60 Z" fill="black"/>`);

// --- Round 1: sector-spanning pack reusing existing public/images/ PNGs ---
// (Natural Gas, Water & Wastewater, Oil & Petrochemical, Power/Electrical,
// HVAC/BMS, District Heating, Fire & Safety, Agriculture, Process/Manufacturing)
const industrialToolboxItems = [
  // --- Pumps ---
  { groupid: '500', id: '500', type: 'Water Pump', imagePath: '/images/pump_green.png', colourType: '0', view: '1' },
  { groupid: '500', id: '501', type: 'Water Pump', imagePath: '/images/pump_red.png', colourType: '1', view: '0' },
  { groupid: '500', id: '502', type: 'Water Pump', imagePath: '/images/pump_blue.png', colourType: '2', view: '0' },

  { groupid: '501', id: '503', type: 'Fuel Transfer Pump', imagePath: '/images/pump_green_v1.png', colourType: '0', view: '1' },
  { groupid: '501', id: '504', type: 'Fuel Transfer Pump', imagePath: '/images/pump_red_v1.png', colourType: '1', view: '0' },
  { groupid: '501', id: '505', type: 'Fuel Transfer Pump', imagePath: '/images/pump_blue_v1.png', colourType: '2', view: '0' },

  { groupid: '502', id: '506', type: 'Chemical Dosing Pump', imagePath: '/images/pneumaticpump_green_v1.png', colourType: '0', view: '1' },
  { groupid: '502', id: '507', type: 'Chemical Dosing Pump', imagePath: '/images/pneumaticpump_red_v1.png', colourType: '1', view: '0' },
  { groupid: '502', id: '508', type: 'Chemical Dosing Pump', imagePath: '/images/pneumaticpump_blue_v1.png', colourType: '2', view: '0' },

  { groupid: '503', id: '509', type: 'Irrigation Pump', imagePath: '/images/pneumaticpump_green_v2.png', colourType: '0', view: '1' },
  { groupid: '503', id: '510', type: 'Irrigation Pump', imagePath: '/images/pneumaticpump_red_v2.png', colourType: '1', view: '0' },
  { groupid: '503', id: '511', type: 'Irrigation Pump', imagePath: '/images/pneumaticpump_blue_v2.png', colourType: '2', view: '0' },

  { groupid: '504', id: '512', type: 'Slurry Pump', imagePath: '/images/pneumaticpump_green_v3.png', colourType: '0', view: '1' },
  { groupid: '504', id: '513', type: 'Slurry Pump', imagePath: '/images/pneumaticpump_red_v3.png', colourType: '1', view: '0' },
  { groupid: '504', id: '514', type: 'Slurry Pump', imagePath: '/images/pneumaticpump_blue_v3.png', colourType: '2', view: '0' },

  // --- Valves ---
  { groupid: '505', id: '515', type: 'Shutoff Valve', imagePath: '/images/valve_green.png', colourType: '0', view: '1' },
  { groupid: '505', id: '516', type: 'Shutoff Valve', imagePath: '/images/valve_red.png', colourType: '1', view: '0' },

  { groupid: '506', id: '517', type: 'Control Valve', imagePath: '/images/v_hor_green.png', colourType: '0', view: '1' },
  { groupid: '506', id: '518', type: 'Control Valve', imagePath: '/images/v_hor_red.png', colourType: '1', view: '0' },
  { groupid: '506', id: '519', type: 'Control Valve', imagePath: '/images/v_hor_blue.png', colourType: '2', view: '0' },

  { groupid: '507', id: '520', type: 'Vertical Control Valve', imagePath: '/images/v_ver1_green.png', colourType: '0', view: '1' },
  { groupid: '507', id: '521', type: 'Vertical Control Valve', imagePath: '/images/v_ver1_red.png', colourType: '1', view: '0' },
  { groupid: '507', id: '522', type: 'Vertical Control Valve', imagePath: '/images/v_ver1_blue.png', colourType: '2', view: '0' },

  { groupid: '508', id: '523', type: 'Vertical Isolation Valve', imagePath: '/images/v_ver2_green.png', colourType: '0', view: '1' },
  { groupid: '508', id: '524', type: 'Vertical Isolation Valve', imagePath: '/images/v_ver2_red.png', colourType: '1', view: '0' },
  { groupid: '508', id: '525', type: 'Vertical Isolation Valve', imagePath: '/images/v_ver2_blue.png', colourType: '2', view: '0' },

  { groupid: '509', id: '526', type: 'Process Valve (Type A)', imagePath: '/images/valf1_green.png', colourType: '0', view: '1' },
  { groupid: '509', id: '527', type: 'Process Valve (Type A)', imagePath: '/images/valf1_red.png', colourType: '1', view: '0' },
  { groupid: '509', id: '528', type: 'Process Valve (Type A)', imagePath: '/images/valf1_bue.png', colourType: '2', view: '0' },

  { groupid: '510', id: '529', type: 'Process Valve (Type B)', imagePath: '/images/valf2_green.png', colourType: '0', view: '1' },
  { groupid: '510', id: '530', type: 'Process Valve (Type B)', imagePath: '/images/valf2_red.png', colourType: '1', view: '0' },
  { groupid: '510', id: '531', type: 'Process Valve (Type B)', imagePath: '/images/valf2_bue.png', colourType: '2', view: '0' },

  { groupid: '511', id: '532', type: 'Field Isolation Valve', imagePath: '/images/vana_blue.png', colourType: '0', view: '1' },

  { groupid: '512', id: '533', type: 'Ball Valve', imagePath: '/images/valve_ball_green_v1.png', colourType: '0', view: '1' },
  { groupid: '512', id: '534', type: 'Ball Valve', imagePath: '/images/valve_ball_red_v1.png', colourType: '1', view: '0' },
  { groupid: '512', id: '535', type: 'Ball Valve', imagePath: '/images/valve_ball_blue_v1.png', colourType: '2', view: '0' },
  { groupid: '512', id: '536', type: 'Ball Valve', imagePath: '/images/valve_ball_yellow_v1.png', colourType: '3', view: '0' },

  { groupid: '513', id: '537', type: 'Ball Valve (Compact)', imagePath: '/images/valve_ball_green_v2.png', colourType: '0', view: '1' },
  { groupid: '513', id: '538', type: 'Ball Valve (Compact)', imagePath: '/images/valve_ball_red_v2.png', colourType: '1', view: '0' },
  { groupid: '513', id: '539', type: 'Ball Valve (Compact)', imagePath: '/images/valve_ball_blue_v2.png', colourType: '2', view: '0' },

  { groupid: '514', id: '540', type: 'Globe Valve', imagePath: '/images/valve_globe_green_v1.png', colourType: '0', view: '1' },
  { groupid: '514', id: '541', type: 'Globe Valve', imagePath: '/images/valve_globe_red_v1.png', colourType: '1', view: '0' },
  { groupid: '514', id: '542', type: 'Globe Valve', imagePath: '/images/valve_globe_blue_v1.png', colourType: '2', view: '0' },
  { groupid: '514', id: '543', type: 'Globe Valve', imagePath: '/images/valve_globe_yellow_v1.png', colourType: '3', view: '0' },

  { groupid: '515', id: '544', type: 'Manual Valve (Type 1)', imagePath: '/images/valve_man_v1.png', colourType: '0', view: '1' },
  { groupid: '516', id: '545', type: 'Manual Valve (Type 2)', imagePath: '/images/valve_man_v2.png', colourType: '0', view: '1' },
  { groupid: '517', id: '546', type: 'Manual Valve (Type 3)', imagePath: '/images/valve_man_v3.png', colourType: '0', view: '1' },
  { groupid: '518', id: '547', type: 'Manual Valve (Heavy Duty)', imagePath: '/images/valve_man_v5.png', colourType: '0', view: '1' },
  { groupid: '519', id: '548', type: 'Manual Valve (Compact)', imagePath: '/images/valve_man_v6.png', colourType: '0', view: '1' },

  { groupid: '520', id: '549', type: 'Safety Shutoff Valve', imagePath: '/images/SSV_blue.png', colourType: '0', view: '1' },
  { groupid: '520', id: '550', type: 'Safety Shutoff Valve', imagePath: '/images/SSV_red.png', colourType: '1', view: '0' },

  { groupid: '521', id: '551', type: 'PVC Distribution Valve', imagePath: '/images/PVC_green.png', colourType: '0', view: '1' },
  { groupid: '521', id: '552', type: 'PVC Distribution Valve', imagePath: '/images/PVC_red.png', colourType: '1', view: '0' },
  { groupid: '521', id: '553', type: 'PVC Distribution Valve', imagePath: '/images/PVC_blue.png', colourType: '2', view: '0' },

  // --- Actuators & motors ---
  { groupid: '522', id: '554', type: 'Valve Actuator (Electric)', imagePath: '/images/actuator_green_v1.png', colourType: '0', view: '1' },
  { groupid: '522', id: '555', type: 'Valve Actuator (Electric)', imagePath: '/images/actuator_red_v1.png', colourType: '1', view: '0' },
  { groupid: '522', id: '556', type: 'Valve Actuator (Electric)', imagePath: '/images/actuator_blue_v1.png', colourType: '2', view: '0' },

  { groupid: '523', id: '557', type: 'Valve Actuator (Pneumatic)', imagePath: '/images/actuator_green_v2.png', colourType: '0', view: '1' },
  { groupid: '523', id: '558', type: 'Valve Actuator (Pneumatic)', imagePath: '/images/actuator_red_v2.png', colourType: '1', view: '0' },
  { groupid: '523', id: '559', type: 'Valve Actuator (Pneumatic)', imagePath: '/images/actuator_blue_v2.png', colourType: '2', view: '0' },

  { groupid: '524', id: '560', type: 'Valve Actuator (Transitioning)', imagePath: '/images/actuator_greenblue_v1.png', colourType: '0', view: '1' },

  { groupid: '525', id: '561', type: 'Electric Motor', imagePath: '/images/motor_green_v1.png', colourType: '0', view: '1' },
  { groupid: '525', id: '562', type: 'Electric Motor', imagePath: '/images/motor_red_v1.png', colourType: '1', view: '0' },
  { groupid: '525', id: '563', type: 'Electric Motor', imagePath: '/images/motor_blue_v1.png', colourType: '2', view: '0' },

  { groupid: '526', id: '564', type: 'Pump Drive Motor', imagePath: '/images/motor_green_v2.png', colourType: '0', view: '1' },
  { groupid: '526', id: '565', type: 'Pump Drive Motor', imagePath: '/images/motor_red_v2.png', colourType: '1', view: '0' },
  { groupid: '526', id: '566', type: 'Pump Drive Motor', imagePath: '/images/motor_blue_v2.png', colourType: '2', view: '0' },

  // --- HVAC / filtration ---
  { groupid: '527', id: '567', type: 'HVAC Ventilation Fan', imagePath: '/images/fan_green_v1.png', colourType: '0', view: '1' },
  { groupid: '527', id: '568', type: 'HVAC Ventilation Fan', imagePath: '/images/fan_red_v1.png', colourType: '1', view: '0' },
  { groupid: '527', id: '569', type: 'HVAC Ventilation Fan', imagePath: '/images/fan_blue_v1.png', colourType: '2', view: '0' },
  { groupid: '527', id: '570', type: 'HVAC Ventilation Fan', imagePath: '/images/fan_white_v1.png', colourType: '3', view: '0' },

  { groupid: '528', id: '571', type: 'Inline Filter / Strainer', imagePath: '/images/filter_green.png', colourType: '0', view: '1' },
  { groupid: '528', id: '572', type: 'Inline Filter / Strainer', imagePath: '/images/filter_red.png', colourType: '1', view: '0' },
  { groupid: '528', id: '573', type: 'Inline Filter / Strainer', imagePath: '/images/filter_blue.png', colourType: '2', view: '0' },

  // --- Flow / pressure / temperature instrumentation ---
  // Each analog group below is a green/yellow/red threshold set (Yöntem 3b):
  // the runtime picks the variant whose [minValue,maxValue] contains the tag value.
  { groupid: '529', id: '574', type: 'Water Flow Meter', imagePath: FLOW(GREEN), colourType: '0', minValue: 0, maxValue: 50, view: '1' },
  { groupid: '529', id: '611', type: 'Water Flow Meter', imagePath: FLOW(YELLOW), colourType: '1', minValue: 50.01, maxValue: 80, view: '0' },
  { groupid: '529', id: '612', type: 'Water Flow Meter', imagePath: FLOW(RED), colourType: '2', minValue: 80.01, maxValue: 9999, view: '0' },

  { groupid: '530', id: '575', type: 'Gas Flow Meter', imagePath: FLOW(GREEN), colourType: '0', minValue: 0, maxValue: 500, view: '1' },
  { groupid: '530', id: '613', type: 'Gas Flow Meter', imagePath: FLOW(YELLOW), colourType: '1', minValue: 500.01, maxValue: 800, view: '0' },
  { groupid: '530', id: '614', type: 'Gas Flow Meter', imagePath: FLOW(RED), colourType: '2', minValue: 800.01, maxValue: 9999, view: '0' },

  { groupid: '531', id: '576', type: 'Oil Flow Meter', imagePath: FLOW(GREEN), colourType: '0', minValue: 0, maxValue: 30, view: '1' },
  { groupid: '531', id: '615', type: 'Oil Flow Meter', imagePath: FLOW(YELLOW), colourType: '1', minValue: 30.01, maxValue: 50, view: '0' },
  { groupid: '531', id: '616', type: 'Oil Flow Meter', imagePath: FLOW(RED), colourType: '2', minValue: 50.01, maxValue: 9999, view: '0' },

  { groupid: '532', id: '577', type: 'Pressure Transmitter', imagePath: GAUGE(GREEN), colourType: '0', minValue: 0, maxValue: 8, view: '1' },
  { groupid: '532', id: '617', type: 'Pressure Transmitter', imagePath: GAUGE(YELLOW), colourType: '1', minValue: 8.01, maxValue: 12, view: '0' },
  { groupid: '532', id: '618', type: 'Pressure Transmitter', imagePath: GAUGE(RED), colourType: '2', minValue: 12.01, maxValue: 9999, view: '0' },

  { groupid: '533', id: '578', type: 'Wellhead Pressure Transmitter', imagePath: GAUGE(GREEN), colourType: '0', minValue: 0, maxValue: 150, view: '1' },
  { groupid: '533', id: '619', type: 'Wellhead Pressure Transmitter', imagePath: GAUGE(YELLOW), colourType: '1', minValue: 150.01, maxValue: 200, view: '0' },
  { groupid: '533', id: '620', type: 'Wellhead Pressure Transmitter', imagePath: GAUGE(RED), colourType: '2', minValue: 200.01, maxValue: 9999, view: '0' },

  { groupid: '534', id: '579', type: 'Network Pressure Transmitter', imagePath: GAUGE(GREEN), colourType: '0', minValue: 0, maxValue: 6, view: '1' },
  { groupid: '534', id: '621', type: 'Network Pressure Transmitter', imagePath: GAUGE(YELLOW), colourType: '1', minValue: 6.01, maxValue: 8, view: '0' },
  { groupid: '534', id: '622', type: 'Network Pressure Transmitter', imagePath: GAUGE(RED), colourType: '2', minValue: 8.01, maxValue: 9999, view: '0' },

  { groupid: '535', id: '580', type: 'Differential Pressure Transmitter', imagePath: GAUGE(GREEN), colourType: '0', minValue: 0, maxValue: 0.5, view: '1' },
  { groupid: '535', id: '623', type: 'Differential Pressure Transmitter', imagePath: GAUGE(YELLOW), colourType: '1', minValue: 0.51, maxValue: 1, view: '0' },
  { groupid: '535', id: '624', type: 'Differential Pressure Transmitter', imagePath: GAUGE(RED), colourType: '2', minValue: 1.01, maxValue: 9999, view: '0' },

  { groupid: '536', id: '581', type: 'Temperature Sensor', imagePath: THERMO(GREEN), colourType: '0', minValue: 0, maxValue: 60, view: '1' },
  { groupid: '536', id: '625', type: 'Temperature Sensor', imagePath: THERMO(YELLOW), colourType: '1', minValue: 60.01, maxValue: 90, view: '0' },
  { groupid: '536', id: '626', type: 'Temperature Sensor', imagePath: THERMO(RED), colourType: '2', minValue: 90.01, maxValue: 9999, view: '0' },

  { groupid: '537', id: '582', type: 'Room Temperature Sensor', imagePath: THERMO(GREEN), colourType: '0', minValue: 18, maxValue: 26, view: '1' },
  { groupid: '537', id: '627', type: 'Room Temperature Sensor', imagePath: THERMO(YELLOW), colourType: '1', minValue: 26.01, maxValue: 30, view: '0' },
  { groupid: '537', id: '628', type: 'Room Temperature Sensor', imagePath: THERMO(RED), colourType: '2', minValue: 30.01, maxValue: 9999, view: '0' },

  { groupid: '538', id: '583', type: 'Supply Temperature Sensor', imagePath: THERMO(GREEN), colourType: '0', minValue: 65, maxValue: 85, view: '1' },
  { groupid: '538', id: '629', type: 'Supply Temperature Sensor', imagePath: THERMO(YELLOW), colourType: '1', minValue: 85.01, maxValue: 95, view: '0' },
  { groupid: '538', id: '630', type: 'Supply Temperature Sensor', imagePath: THERMO(RED), colourType: '2', minValue: 95.01, maxValue: 9999, view: '0' },

  // --- Gas safety & compression ---
  // LEL = Lower Explosive Limit %, the real unit already seeded in the backend (ConnDataUnit).
  { groupid: '539', id: '584', type: 'Combustible Gas Detector', imagePath: HAZARD(GREEN, 'LEL'), colourType: '0', minValue: 0, maxValue: 19.99, view: '1' },
  { groupid: '539', id: '631', type: 'Combustible Gas Detector', imagePath: HAZARD(YELLOW, 'LEL'), colourType: '1', minValue: 20, maxValue: 39.99, view: '0' },
  { groupid: '539', id: '632', type: 'Combustible Gas Detector', imagePath: HAZARD(RED, 'LEL'), colourType: '2', minValue: 40, maxValue: 100, view: '0' },

  { groupid: '540', id: '585', type: 'Toxic Gas Detector', imagePath: HAZARD(GREEN, 'GAS'), colourType: '0', minValue: 0, maxValue: 24.99, view: '1' },
  { groupid: '540', id: '633', type: 'Toxic Gas Detector', imagePath: HAZARD(YELLOW, 'GAS'), colourType: '1', minValue: 25, maxValue: 49.99, view: '0' },
  { groupid: '540', id: '634', type: 'Toxic Gas Detector', imagePath: HAZARD(RED, 'GAS'), colourType: '2', minValue: 50, maxValue: 100, view: '0' },

  { groupid: '541', id: '586', type: 'Gas Compressor', imagePath: '/images/gas_comp_green_v1.png', colourType: '0', view: '1' },
  { groupid: '541', id: '587', type: 'Gas Compressor', imagePath: '/images/gas_comp_red_v1.png', colourType: '1', view: '0' },
  { groupid: '541', id: '588', type: 'Gas Compressor', imagePath: '/images/gas_comp_blue_v1.png', colourType: '2', view: '0' },

  { groupid: '542', id: '589', type: 'Chemical Dispenser Unit', imagePath: '/images/dispanser_green_v2.png', colourType: '0', view: '1' },
  { groupid: '542', id: '590', type: 'Chemical Dispenser Unit', imagePath: '/images/dispanser_red_v1.png', colourType: '1', view: '0' },

  // --- Alarms & HMI controls ---
  { groupid: '543', id: '591', type: 'Alarm Panel', imagePath: '/images/alarm.png', colourType: '0', view: '1' },
  { groupid: '544', id: '592', type: 'Alarm Beacon', imagePath: '/images/alarm2.png', colourType: '0', view: '1' },

  { groupid: '545', id: '593', type: 'Alarm Status Indicator', imagePath: '/images/alarm_red_v1.png', colourType: '0', view: '1' },
  { groupid: '545', id: '594', type: 'Alarm Status Indicator', imagePath: '/images/alarm_yellow_v1.png', colourType: '1', view: '0' },

  { groupid: '546', id: '595', type: 'Start Button', imagePath: '/images/btn_unpressed_start.png', colourType: '0', view: '1' },
  { groupid: '546', id: '596', type: 'Start Button', imagePath: '/images/btn_pressed_start.png', colourType: '1', view: '0' },

  { groupid: '547', id: '597', type: 'Stop Button', imagePath: '/images/btn_unpressed_stop.png', colourType: '0', view: '1' },
  { groupid: '547', id: '598', type: 'Stop Button', imagePath: '/images/btn_pressed_stop.png', colourType: '1', view: '0' },

  { groupid: '548', id: '599', type: 'Acknowledge Button', imagePath: '/images/btn_unpressed_ack.png', colourType: '0', view: '1' },
  { groupid: '548', id: '600', type: 'Acknowledge Button', imagePath: '/images/btn_pressed_ack.png', colourType: '1', view: '0' },

  { groupid: '549', id: '601', type: 'Emergency Stop', imagePath: '/images/stop.png', colourType: '0', view: '1' },

  // --- Heat sources ---
  { groupid: '550', id: '602', type: 'Boiler', imagePath: '/images/boiler_v1.png', colourType: '0', view: '1' },
  { groupid: '551', id: '603', type: 'Duct Heater', imagePath: '/images/heater_raw.png', colourType: '0', view: '1' },

  // --- Emergency shutdown ---
  { groupid: '552', id: '604', type: 'Emergency Shutdown Valve', imagePath: '/images/ESD.png', colourType: '0', view: '1' },
  { groupid: '553', id: '605', type: 'ESD Panel', imagePath: '/images/ESD1.png', colourType: '0', view: '1' },

  // --- Piping network primitives (Water/Gas/Oil/District Heating) ---
  { groupid: '554', id: '606', type: 'Pipe Segment', imagePath: '/images/pipe_v0.png', colourType: '0', view: '1' },
  { groupid: '555', id: '607', type: 'Pipe Elbow', imagePath: '/images/elbow_v0.png', colourType: '0', view: '1' },
  { groupid: '556', id: '608', type: 'Pipe Flange', imagePath: '/images/flange_v0.png', colourType: '0', view: '1' },
  { groupid: '557', id: '609', type: 'Tee Junction', imagePath: '/images/tee_junction_v0.png', colourType: '0', view: '1' },
  { groupid: '558', id: '610', type: '4-Way Junction', imagePath: '/images/4wayJunction_v0.png', colourType: '0', view: '1' },
];

// --- Round 2: 20-sector flagship pack (Solar, Power, BMS, HVAC, Water, Oil & Gas,
// Data Center, Wind, BESS, Automotive, Food & Beverage, Chemical, Mining,
// Pharma, Steel, Agriculture, Marine, Cold Chain, Cement, Textile) ---
const sectorIconItems = [
  // 1) Solar Power (GES)
  { groupid: '700', id: '700', type: 'Solar Inverter', imagePath: PANEL(ORANGE, 'INV'), colourType: '0', view: '1' },
  { groupid: '701', id: '701', type: 'Pyranometer (Solar Irradiance Sensor)', imagePath: SUN(ORANGE), colourType: '0', view: '1' },
  { groupid: '702', id: '702', type: 'String Monitoring Box', imagePath: PANEL(ORANGE, 'STR'), colourType: '0', view: '1' },

  // 2) Power Generation & Distribution
  { groupid: '703', id: '703', type: 'Power Transformer', imagePath: TRANSFORMER(BLUE), colourType: '0', view: '1' },
  { groupid: '704', id: '704', type: 'Smart Meter', imagePath: PANEL(BLUE, 'kWh'), colourType: '0', view: '1' },
  { groupid: '705', id: '705', type: 'Circuit Breaker', imagePath: BREAKER(BLUE), colourType: '0', view: '1' },
  { groupid: '706', id: '706', type: 'Protection Relay', imagePath: PANEL(BLUE, 'RELAY'), colourType: '0', view: '1' },

  // 3) Smart Buildings & Facility Management (BMS)
  { groupid: '707', id: '707', type: 'Elevator', imagePath: ELEVATOR(GREEN), colourType: '0', view: '1' },
  { groupid: '707', id: '708', type: 'Elevator', imagePath: ELEVATOR(GRAY), colourType: '1', view: '0' },
  { groupid: '707', id: '709', type: 'Elevator', imagePath: ELEVATOR(RED), colourType: '2', view: '0' },
  { groupid: '710', id: '710', type: 'Access Control Card Reader', imagePath: CARD(PURPLE), colourType: '0', view: '1' },
  { groupid: '711', id: '711', type: 'Fire Alarm Control Panel', imagePath: PANEL(RED, 'FIRE'), colourType: '0', view: '1' },
  { groupid: '712', id: '712', type: 'Lighting Control Panel', imagePath: PANEL(PURPLE, 'LIGHT'), colourType: '0', view: '1' },

  // 4) HVAC & Climate Control
  { groupid: '713', id: '713', type: 'Chiller Unit', imagePath: CHILLER(TEAL), colourType: '0', view: '1' },
  { groupid: '714', id: '714', type: 'Air Handling Unit (AHU)', imagePath: '/images/fan_blue_v1.png', colourType: '0', view: '1' },
  { groupid: '715', id: '715', type: 'Humidity / Temperature Controller', imagePath: THERMO(TEAL), colourType: '0', view: '1' },

  // 5) Water & Wastewater Treatment
  { groupid: '716', id: '716', type: 'pH / Chlorine Analyzer', imagePath: PANEL(BLUE, 'pH'), colourType: '0', view: '1' },
  { groupid: '717', id: '717', type: 'Lift Station Pump', imagePath: '/images/pump_green.png', colourType: '0', view: '1' },

  // 6) Oil & Natural Gas
  { groupid: '718', id: '718', type: 'Flow Computer', imagePath: PANEL(ORANGE, 'FC'), colourType: '0', view: '1' },
  { groupid: '719', id: '719', type: 'Wellhead Control (Christmas Tree)', imagePath: WELLHEAD(ORANGE), colourType: '0', view: '1' },
  { groupid: '720', id: '720', type: 'Pipeline Pressure Monitor', imagePath: GAUGE(ORANGE), colourType: '0', view: '1' },

  // 7) Data Centers
  { groupid: '721', id: '721', type: 'Server Rack', imagePath: RACK(BLUE), colourType: '0', view: '1' },
  { groupid: '722', id: '722', type: 'UPS (Uninterruptible Power Supply)', imagePath: BATTERY(BLUE), colourType: '0', view: '1' },
  { groupid: '723', id: '723', type: 'PDU (Power Distribution Unit)', imagePath: PANEL(BLUE, 'PDU'), colourType: '0', view: '1' },
  { groupid: '724', id: '724', type: 'Battery Monitoring Unit', imagePath: BATTERY(PURPLE), colourType: '0', view: '1' },

  // 8) Wind Power (RES)
  { groupid: '725', id: '725', type: 'Wind Turbine', imagePath: TURBINE(GREEN), colourType: '0', view: '1' },
  { groupid: '725', id: '726', type: 'Wind Turbine', imagePath: TURBINE(GRAY), colourType: '1', view: '0' },
  { groupid: '725', id: '727', type: 'Wind Turbine', imagePath: TURBINE(RED), colourType: '2', view: '0' },
  { groupid: '728', id: '728', type: 'Pitch Control Actuator', imagePath: '/images/actuator_blue_v1.png', colourType: '0', view: '1' },
  { groupid: '729', id: '729', type: 'Meteorological Mast', imagePath: MAST(TEAL), colourType: '0', view: '1' },

  // 9) Battery Energy Storage Systems (BESS)
  { groupid: '730', id: '730', type: 'BESS Battery Bank', imagePath: BATTERY(GREEN), colourType: '0', view: '1' },
  { groupid: '730', id: '731', type: 'BESS Battery Bank', imagePath: BATTERY(GRAY), colourType: '1', view: '0' },
  { groupid: '730', id: '732', type: 'BESS Battery Bank', imagePath: BATTERY(RED), colourType: '2', view: '0' },
  { groupid: '733', id: '733', type: 'Charge / Discharge Controller', imagePath: PANEL(GREEN, 'BMS'), colourType: '0', view: '1' },

  // 10) Automotive Industry
  { groupid: '734', id: '734', type: 'Welding Robot Arm', imagePath: ROBOT(ORANGE), colourType: '0', view: '1' },
  { groupid: '734', id: '735', type: 'Welding Robot Arm', imagePath: ROBOT(GRAY), colourType: '1', view: '0' },
  { groupid: '734', id: '736', type: 'Welding Robot Arm', imagePath: ROBOT(RED), colourType: '2', view: '0' },
  { groupid: '737', id: '737', type: 'Paint Shop Air Handling Unit', imagePath: CHILLER(PURPLE), colourType: '0', view: '1' },
  { groupid: '738', id: '738', type: 'Assembly Line Conveyor', imagePath: CONVEYOR(GREEN), colourType: '0', view: '1' },
  { groupid: '738', id: '739', type: 'Assembly Line Conveyor', imagePath: CONVEYOR(GRAY), colourType: '1', view: '0' },
  { groupid: '738', id: '740', type: 'Assembly Line Conveyor', imagePath: CONVEYOR(RED), colourType: '2', view: '0' },

  // 11) Food & Beverage Production
  { groupid: '741', id: '741', type: 'Autoclave / Sterilizer', imagePath: AUTOCLAVE(TEAL), colourType: '0', view: '1' },
  { groupid: '742', id: '742', type: 'Cold Storage Room', imagePath: THERMO(BLUE), colourType: '0', view: '1' },
  { groupid: '743', id: '743', type: 'Filling Line Conveyor', imagePath: CONVEYOR(ORANGE), colourType: '0', view: '1' },

  // 12) Chemical & Petrochemical
  { groupid: '744', id: '744', type: 'Chemical Reactor Vessel', imagePath: TANK(PURPLE), colourType: '0', view: '1' },

  // 13) Mining & Ore Processing
  { groupid: '745', id: '745', type: 'Mining Haul Truck', imagePath: TRUCK(GREEN), colourType: '0', view: '1' },
  { groupid: '745', id: '746', type: 'Mining Haul Truck', imagePath: TRUCK(GRAY), colourType: '1', view: '0' },
  { groupid: '745', id: '747', type: 'Mining Haul Truck', imagePath: TRUCK(RED), colourType: '2', view: '0' },
  { groupid: '748', id: '748', type: 'Conveyor Belt Scale', imagePath: CONVEYOR(PURPLE), colourType: '0', view: '1' },
  { groupid: '749', id: '749', type: 'Crusher Plant', imagePath: CRUSHER(GRAY), colourType: '0', view: '1' },
  { groupid: '750', id: '750', type: 'Mine Ventilation Fan', imagePath: '/images/fan_green_v2.png', colourType: '0', view: '1' },

  // 14) Pharmaceutical Industry
  { groupid: '751', id: '751', type: 'Cleanroom Monitor', imagePath: PANEL(TEAL, 'CLEAN'), colourType: '0', view: '1' },
  { groupid: '752', id: '752', type: 'Sterilization Autoclave', imagePath: AUTOCLAVE(BLUE), colourType: '0', view: '1' },

  // 15) Iron & Steel / Heavy Industry
  { groupid: '753', id: '753', type: 'Blast Furnace', imagePath: FURNACE(RED), colourType: '0', view: '1' },
  { groupid: '754', id: '754', type: 'Rolling Mill Line', imagePath: CONVEYOR(GRAY), colourType: '0', view: '1' },
  { groupid: '755', id: '755', type: 'Gas Analyzer', imagePath: PANEL(GRAY, 'GAS'), colourType: '0', view: '1' },

  // 16) Agriculture & Greenhouses (Smart Farming)
  { groupid: '756', id: '756', type: 'Greenhouse Climate Control', imagePath: GREENHOUSE(GREEN), colourType: '0', view: '1' },
  { groupid: '757', id: '757', type: 'Automatic Irrigation Controller', imagePath: PANEL(GREEN, 'IRR'), colourType: '0', view: '1' },
  { groupid: '758', id: '758', type: 'Fertilizer Dosing Unit', imagePath: '/images/dispanser_green_v2.png', colourType: '0', view: '1' },

  // 17) Maritime & Shipping (Marine)
  { groupid: '759', id: '759', type: 'Ship Engine Room Monitor', imagePath: SHIP(BLUE), colourType: '0', view: '1' },
  { groupid: '760', id: '760', type: 'Fuel Consumption Meter', imagePath: FLOW(BLUE), colourType: '0', view: '1' },
  { groupid: '761', id: '761', type: 'Bilge Pump', imagePath: '/images/pump_red_v1.png', colourType: '0', view: '1' },

  // 18) Logistics & Cold Chain
  { groupid: '762', id: '762', type: 'Reefer Container', imagePath: CONTAINER(BLUE), colourType: '0', view: '1' },
  { groupid: '763', id: '763', type: 'Refrigerated Truck', imagePath: TRUCK(BLUE), colourType: '0', view: '1' },
  { groupid: '764', id: '764', type: 'Warehouse Temperature Mapping', imagePath: THERMO(PURPLE), colourType: '0', view: '1' },

  // 19) Cement & Building Materials
  { groupid: '765', id: '765', type: 'Rotary Kiln', imagePath: DRUM(ORANGE), colourType: '0', view: '1' },
  { groupid: '766', id: '766', type: 'Cement Silo', imagePath: TANK(GRAY), colourType: '0', view: '1' },
  { groupid: '767', id: '767', type: 'Packaging Line', imagePath: CONVEYOR(TEAL), colourType: '0', view: '1' },

  // 20) Textile & Dye House
  { groupid: '768', id: '768', type: 'Dye Vat Controller', imagePath: TANK(RED), colourType: '0', view: '1' },
  { groupid: '769', id: '769', type: 'Fabric Dryer Drum', imagePath: DRUM(PURPLE), colourType: '0', view: '1' },
  { groupid: '770', id: '770', type: 'Fabric Humidity Monitor', imagePath: GAUGE(TEAL), colourType: '0', view: '1' },
];

// --- Connectors: plain line + dashed direction arrow ---
// Unlike every other entry above, these render as NATIVE SVG <line>/<polygon>
// in FlowComponent.js (renderItem(), gated on `isConnector` below) instead of
// an <image>, so their color is genuinely runtime-editable — double-click a
// dropped Line/Arrow to change it, same interaction as the Text Box (bkz.
// TextEditModal.js `simpleColorOnly` mode). `imagePath` here is ONLY the
// static black palette-preview thumbnail; it's never drawn on canvas.
// Only 'Line'/'Arrow' (baseAngle 0) are palette-visible — the old per-direction
// duplicates (Line Vertical, Arrow Left/Up/Down) are hidden via
// ROTATED_DUPLICATE_OF below, same pattern as every other angle-duplicate in
// this file, now that FlowComponent.js supports generic mouse-drag rotation.
// `connectorKind` picks line-vs-arrowhead; `baseAngle` is only meaningful for
// the entries still reachable by a saved item's toolboxId (see below).
// Arrows default to dashed (signal-style) but that's just a starting value —
// double-click a dropped connector to toggle solid/dashed and pick its
// color, same modal as the Text Box.
const connectorPreview = (kind, angle) =>
  svg(`<g transform="rotate(${angle} 48 48)">${
    kind === 'line'
      ? `<line x1="8" y1="48" x2="88" y2="48" stroke="black" stroke-width="6"/>`
      : `<line x1="8" y1="48" x2="72" y2="48" stroke="black" stroke-width="6" stroke-dasharray="14 8"/><polygon points="88,48 68,38 68,58" fill="black"/>`
  }</g>`);
const connectorToolboxItems = [
  { groupid: '800', id: '800', type: 'Line', imagePath: connectorPreview('line', 0), colourType: '0', view: '1', isConnector: true, connectorKind: 'line', baseAngle: 0 },
  { groupid: '801', id: '801', type: 'Line (Vertical)', imagePath: connectorPreview('line', 90), colourType: '0', view: '1', isConnector: true, connectorKind: 'line', baseAngle: 90 },
  { groupid: '802', id: '802', type: 'Arrow', imagePath: connectorPreview('arrow', 0), colourType: '0', view: '1', isConnector: true, connectorKind: 'arrow', baseAngle: 0 },
  { groupid: '803', id: '803', type: 'Arrow (Left)', imagePath: connectorPreview('arrow', 180), colourType: '0', view: '1', isConnector: true, connectorKind: 'arrow', baseAngle: 180 },
  { groupid: '804', id: '804', type: 'Arrow (Up)', imagePath: connectorPreview('arrow', 270), colourType: '0', view: '1', isConnector: true, connectorKind: 'arrow', baseAngle: 270 },
  { groupid: '805', id: '805', type: 'Arrow (Down)', imagePath: connectorPreview('arrow', 90), colourType: '0', view: '1', isConnector: true, connectorKind: 'arrow', baseAngle: 90 },
];

// --- Gap-fill pack: components referenced by the "Sector Demo Kit" artifact
// mimic-screen diagrams that had no real registry entry yet (Su/Elektrik/
// Maden/GES/RES). Same pattern as everywhere above: static single-state
// icons (view:'1', colourType:'0'), inline SVG reusing the shared svg()
// helper and the GREEN/YELLOW/RED/GRAY/BLUE/ORANGE/PURPLE/TEAL palette.
const BARSCREEN = hex => svg(`<rect x="14" y="14" width="68" height="68" fill="none" stroke="black" stroke-width="4"/><line x1="24" y1="14" x2="24" y2="82" stroke="%23${hex}" stroke-width="5"/><line x1="38" y1="14" x2="38" y2="82" stroke="%23${hex}" stroke-width="5"/><line x1="52" y1="14" x2="52" y2="82" stroke="%23${hex}" stroke-width="5"/><line x1="66" y1="14" x2="66" y2="82" stroke="%23${hex}" stroke-width="5"/>`);
const BASIN = hex => svg(`<rect x="10" y="34" width="76" height="46" fill="%23${hex}" stroke="black" stroke-width="4"/><path d="M10 34 Q22 26 34 34 Q46 42 58 34 Q70 26 82 34" fill="none" stroke="black" stroke-width="3"/>`);
const BUSBAR = hex => svg(`<rect x="8" y="42" width="80" height="12" fill="%23${hex}" stroke="black" stroke-width="3"/><line x1="20" y1="54" x2="20" y2="72" stroke="black" stroke-width="4"/><line x1="48" y1="54" x2="48" y2="72" stroke="black" stroke-width="4"/><line x1="76" y1="54" x2="76" y2="72" stroke="black" stroke-width="4"/>`);
const GENERATOR = hex => svg(`<circle cx="48" cy="48" r="36" fill="%23${hex}" stroke="black" stroke-width="4"/><text x="48" y="61" font-size="34" font-family="Arial,sans-serif" font-weight="700" text-anchor="middle" fill="black">G</text>`);
const VIBSENSOR = hex => svg(`<path d="M8 48 Q16 30 24 48 T40 48 T50 48" fill="none" stroke="black" stroke-width="4" stroke-linecap="round"/><rect x="52" y="36" width="24" height="24" rx="3" fill="%23${hex}" stroke="black" stroke-width="4"/>`);
const VIBSCREEN = hex => svg(`<g transform="rotate(-8 48 48)"><rect x="14" y="30" width="68" height="36" fill="%23${hex}" stroke="black" stroke-width="4"/><line x1="28" y1="30" x2="28" y2="66" stroke="black" stroke-width="2"/><line x1="42" y1="30" x2="42" y2="66" stroke="black" stroke-width="2"/><line x1="56" y1="30" x2="56" y2="66" stroke="black" stroke-width="2"/><line x1="70" y1="30" x2="70" y2="66" stroke="black" stroke-width="2"/></g>`);
const STOCKPILE = hex => svg(`<path d="M10 82 L48 20 L86 82 Z" fill="%23${hex}" stroke="black" stroke-width="4"/><line x1="10" y1="82" x2="86" y2="82" stroke="black" stroke-width="4"/>`);
const PVPANEL = hex => svg(`<rect x="10" y="20" width="76" height="56" fill="%23${hex}" stroke="black" stroke-width="4"/><line x1="10" y1="39" x2="86" y2="39" stroke="black" stroke-width="2"/><line x1="10" y1="58" x2="86" y2="58" stroke="black" stroke-width="2"/><line x1="29" y1="20" x2="29" y2="76" stroke="black" stroke-width="2"/><line x1="48" y1="20" x2="48" y2="76" stroke="black" stroke-width="2"/><line x1="67" y1="20" x2="67" y2="76" stroke="black" stroke-width="2"/>`);
// Single-line-diagram disconnector/isolator switch symbol — a broken line
// with a diagonal "blade", distinct from Circuit Breaker's box-and-dot
// symbol. No-load manual isolation switch, not a fault-interrupting breaker.
const DISCONNECTOR = hex => svg(`<line x1="48" y1="8" x2="48" y2="38" stroke="black" stroke-width="4"/><line x1="48" y1="58" x2="48" y2="88" stroke="black" stroke-width="4"/><line x1="48" y1="38" x2="70" y2="58" stroke="%23${hex}" stroke-width="5" stroke-linecap="round"/><circle cx="48" cy="38" r="5" fill="black"/><circle cx="48" cy="58" r="5" fill="black"/>`);
const gapFillToolboxItems = [
  // Water & Wastewater Treatment
  { groupid: '806', id: '806', type: 'Bar Screen', imagePath: BARSCREEN(BLUE), colourType: '0', view: '1' },
  { groupid: '807', id: '807', type: 'Coagulation Tank', imagePath: TANK(PURPLE), colourType: '0', view: '1' },
  { groupid: '808', id: '808', type: 'Sedimentation Basin', imagePath: BASIN(TEAL), colourType: '0', view: '1' },
  { groupid: '809', id: '809', type: 'Sludge Thickener', imagePath: BASIN(GRAY), colourType: '0', view: '1' },
  { groupid: '810', id: '810', type: 'Clean Water Reservoir', imagePath: TANK(BLUE), colourType: '0', view: '1' },
  // Power Generation & Distribution
  { groupid: '811', id: '811', type: 'Busbar', imagePath: BUSBAR(ORANGE), colourType: '0', view: '1' },
  { groupid: '812', id: '812', type: 'Feeder', imagePath: PANEL(ORANGE, 'FDR'), colourType: '0', view: '1' },
  { groupid: '813', id: '813', type: 'Backup Generator', imagePath: GENERATOR(ORANGE), colourType: '0', view: '1' },
  // Mining & Ore Processing
  { groupid: '814', id: '814', type: 'Vibration Sensor', imagePath: VIBSENSOR(GRAY), colourType: '0', view: '1' },
  { groupid: '815', id: '815', type: 'Vibrating Screen', imagePath: VIBSCREEN(GRAY), colourType: '0', view: '1' },
  { groupid: '816', id: '816', type: 'Stockpile', imagePath: STOCKPILE(GRAY), colourType: '0', view: '1' },
  // Solar (GES) / Wind (RES) — SCADA and Grid Metering shared by both
  { groupid: '817', id: '817', type: 'PV Panel Array', imagePath: PVPANEL(ORANGE), colourType: '0', view: '1' },
  { groupid: '818', id: '818', type: 'SCADA / Monitoring Panel', imagePath: PANEL(TEAL, 'SCADA'), colourType: '0', view: '1' },
  { groupid: '819', id: '819', type: 'Grid Connection Metering', imagePath: PANEL(BLUE, 'GRID'), colourType: '0', view: '1' },
  { groupid: '820', id: '820', type: 'Disconnector', imagePath: DISCONNECTOR(ORANGE), colourType: '0', view: '1' },
];

const baseToolboxItems = [
  {
    groupid: '1',
    id: '1',
    type: 'Pipe',
    imagePath: '/images2/001v01c01a01.png',
    colourType: '0',
    view: '1',
  },

  {
    groupid: '201',
    id: '201',
    type: 'Pipe',
    imagePath: '/images2/005v01c01a01.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '203',
    id: '203',
    type: 'Pipe',
    imagePath: '/images2/006v01c01a01.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '2',
    id: '2',
    type: 'Pipe',
    imagePath: '/images2/001v01c01a02.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '202',
    id: '202',
    type: 'Pipe',
    imagePath: '/images2/005v01c01a02.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '204',
    id: '204',
    type: 'Pipe',
    imagePath: '/images2/006v01c01a02.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '3',
    id: '3',
    type: 'Pipe',
    imagePath: '/images2/002v01c01a01.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '4',
    id: '4',
    type: 'Pipe',
    imagePath: '/images2/002v01c01a02.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '5',
    id: '5',
    type: 'Pipe',
    imagePath: '/images2/002v01c01a03.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '6',
    id: '6',
    type: 'Pipe',
    imagePath: '/images2/002v01c01a04.png',
    colourType: '0',
    view: '1',
  },

  {
    groupid: '7',
    id: '7',
    type: 'Pipe',
    imagePath: '/images2/003v01c01a01.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '8',
    id: '8',
    type: 'Pipe',
    imagePath: '/images2/003v01c01a02.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '9',
    id: '9',
    type: 'Pipe',
    imagePath: '/images2/003v01c01a03.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '10',
    id: '10',
    type: 'Pipe',
    imagePath: '/images2/003v01c01a04.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '11',
    id: '11',
    type: 'Pipe',
    imagePath: '/images2/004v01c01a01.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '12',
    id: '12',
    type: '010v01c01a01',
    imagePath: '/images2/010v01c01a01.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '12',
    id: '13',
    type: '010v01c02a01',
    imagePath: '/images2/010v01c02a01.png',
    colourType: '1',
    view: '0',
  },
  {
    groupid: '12',
    id: '14',
    type: '010v01c03a01',
    imagePath: '/images2/010v01c03a01.png',
    colourType: '2',
    view: '0',
  },
  {
    groupid: '12',
    id: '15',
    type: '010v01c04a01',
    imagePath: '/images2/010v01c04a01.png',
    colourType: '3',
    view: '0',
  },

  {
    groupid: '13',
    id: '16',
    type: '010v01c01a02',
    imagePath: '/images2/010v01c01a02.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '13',
    id: '17',
    type: '010v01c02a02',
    imagePath: '/images2/010v01c02a02.png',
    colourType: '1',
    view: '0',
  },
  {
    groupid: '13',
    id: '18',
    type: '010v01c03a02',
    imagePath: '/images2/010v01c03a02.png',
    colourType: '2',
    view: '0',
  },
  {
    groupid: '13',
    id: '19',
    type: '010v01c04a02',
    imagePath: '/images2/010v01c04a02.png',
    colourType: '3',
    view: '0',
  },

  {
    groupid: '14',
    id: '20',
    type: '010v01c01a03',
    imagePath: '/images2/010v01c01a03.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '14',
    id: '21',
    type: '010v01c02a03',
    imagePath: '/images2/010v01c02a03.png',
    colourType: '1',
    view: '0',
  },
  {
    groupid: '14',
    id: '22',
    type: '010v01c03a03',
    imagePath: '/images2/010v01c03a03.png',
    colourType: '2',
    view: '0',
  },
  {
    groupid: '14',
    id: '23',
    type: '010v01c04a03',
    imagePath: '/images2/010v01c04a03.png',
    colourType: '3',
    view: '0',
  },

  {
    groupid: '15',
    id: '24',
    type: '010v01c01a04',
    imagePath: '/images2/010v01c01a04.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '15',
    id: '25',
    type: '010v01c02a04',
    imagePath: '/images2/010v01c02a04.png',
    colourType: '1',
    view: '0',
  },
  {
    groupid: '15',
    id: '26',
    type: '010v01c03a04',
    imagePath: '/images2/010v01c03a04.png',
    colourType: '2',
    view: '0',
  },
  {
    groupid: '15',
    id: '27',
    type: '010v01c04a04',
    imagePath: '/images2/010v01c04a04.png',
    colourType: '3',
    view: '0',
  },

  {
    groupid: '16',
    id: '28',
    type: '011v01c01a01',
    imagePath: '/images2/011v01c01a01.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '16',
    id: '29',
    type: '011v01c02a01',
    imagePath: '/images2/011v01c02a01.png',
    colourType: '1',
    view: '0',
  },
  {
    groupid: '16',
    id: '30',
    type: '011v01c02a01',
    imagePath: '/images2/011v01c02a01.png',
    colourType: '2',
    view: '0',
  },
  {
    groupid: '16',
    id: '31',
    type: '011v01c04a01',
    imagePath: '/images2/011v01c04a01.png',
    colourType: '3',
    view: '0',
  },

  {
    groupid: '17',
    id: '32',
    type: '011v01c01a02',
    imagePath: '/images2/011v01c01a02.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '17',
    id: '33',
    type: '011v01c02a02',
    imagePath: '/images2/011v01c02a02.png',
    colourType: '1',
    view: '0',
  },
  {
    groupid: '17',
    id: '34',
    type: '011v01c02a02',
    imagePath: '/images2/011v01c02a02.png',
    colourType: '2',
    view: '0',
  },
  {
    groupid: '17',
    id: '35',
    type: '011v01c04a02',
    imagePath: '/images2/011v01c04a02.png',
    colourType: '3',
    view: '0',
  },

  {
    groupid: '18',
    id: '36',
    type: '011v01c01a03',
    imagePath: '/images2/011v01c01a03.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '18',
    id: '37',
    type: '011v01c02a03',
    imagePath: '/images2/011v01c02a03.png',
    colourType: '1',
    view: '0',
  },
  {
    groupid: '18',
    id: '38',
    type: '011v01c02a03',
    imagePath: '/images2/011v01c02a03.png',
    colourType: '2',
    view: '0',
  },
  {
    groupid: '18',
    id: '39',
    type: '011v01c04a03',
    imagePath: '/images2/011v01c04a03.png',
    colourType: '3',
    view: '0',
  },

  {
    groupid: '19',
    id: '40',
    type: '011v01c01a04',
    imagePath: '/images2/011v01c01a04.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '19',
    id: '41',
    type: '011v01c02a04',
    imagePath: '/images2/011v01c02a04.png',
    colourType: '1',
    view: '0',
  },
  {
    groupid: '19',
    id: '42',
    type: '011v01c02a04',
    imagePath: '/images2/011v01c02a04.png',
    colourType: '2',
    view: '0',
  },
  {
    groupid: '19',
    id: '43',
    type: '011v01c04a04',
    imagePath: '/images2/011v01c04a04.png',
    colourType: '3',
    view: '0',
  },

  {
    groupid: '20',
    id: '44',
    type: '012v01c01a01',
    imagePath: '/images2/012v01c01a01.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '20',
    id: '45',
    type: '012v01c02a01',
    imagePath: '/images2/012v01c02a01.png',
    colourType: '1',
    view: '0',
  },
  {
    groupid: '20',
    id: '46',
    type: '012v01c03a01',
    imagePath: '/images2/012v01c03a01.png',
    colourType: '2',
    view: '0',
  },
  {
    groupid: '20',
    id: '47',
    type: '012v01c04a01',
    imagePath: '/images2/012v01c04a01.png',
    colourType: '3',
    view: '0',
  },

  // {
  //   groupid: '20',
  //   id: '182',
  //   type: '012v01c05a01',
  //   imagePath: '/images2/012v01c05a01.png',
  //   colourType: '4',
  //   view: '0',
  // },

  {
    groupid: '21',
    id: '48',
    type: '012v01c01a02',
    imagePath: '/images2/012v01c01a02.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '21',
    id: '49',
    type: '012v01c02a02',
    imagePath: '/images2/012v01c02a02.png',
    colourType: '1',
    view: '0',
  },
  {
    groupid: '21',
    id: '50',
    type: '012v01c03a02',
    imagePath: '/images2/012v01c03a02.png',
    colourType: '2',
    view: '0',
  },
  {
    groupid: '21',
    id: '51',
    type: '012v01c04a02',
    imagePath: '/images2/012v01c04a02.png',
    colourType: '3',
    view: '0',
  },
  // {
  //   groupid: '21',
  //   id: '183',
  //   type: '012v01c05a02',
  //   imagePath: '/images2/012v01c05a02.png',
  //   colourType: '4',
  //   view: '0',
  // },

  {
    groupid: '22',
    id: '52',
    type: '012v01c01a03',
    imagePath: '/images2/012v01c01a03.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '22',
    id: '53',
    type: '012v01c02a03',
    imagePath: '/images2/012v01c02a03.png',
    colourType: '1',
    view: '0',
  },
  {
    groupid: '22',
    id: '54',
    type: '012v01c03a03',
    imagePath: '/images2/012v01c03a03.png',
    colourType: '2',
    view: '0',
  },
  {
    groupid: '22',
    id: '55',
    type: '012v01c04a03',
    imagePath: '/images2/012v01c04a03.png',
    colourType: '3',
    view: '0',
  },

  // {
  //   groupid: '22',
  //   id: '184',
  //   type: '012v01c05a03',
  //   imagePath: '/images2/012v01c05a03.png',
  //   colourType: '4',
  //   view: '0',
  // },

  {
    groupid: '23',
    id: '56',
    type: '012v01c01a04',
    imagePath: '/images2/012v01c01a04.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '23',
    id: '57',
    type: '012v01c02a04',
    imagePath: '/images2/012v01c02a04.png',
    colourType: '1',
    view: '0',
  },
  {
    groupid: '23',
    id: '58',
    type: '012v01c03a04',
    imagePath: '/images2/012v01c03a04.png',
    colourType: '2',
    view: '0',
  },
  {
    groupid: '23',
    id: '59',
    type: '012v01c04a04',
    imagePath: '/images2/012v01c04a04.png',
    colourType: '3',
    view: '0',
  },
  // {
  //   groupid: '23',
  //   id: '185',
  //   type: '012v01c05a04',
  //   imagePath: '/images2/012v01c05a04.png',
  //   colourType: '4',
  //   view: '0',
  // },
  {
    groupid: '24',
    id: '60',
    type: '020v01c01a01',
    imagePath: '/images2/020v01c01a01.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '25',
    id: '61',
    type: '020v01c01a02',
    imagePath: '/images2/020v01c01a02.png',
    colourType: '0',
    view: '1',
  },

  {
    groupid: '26',
    id: '62',
    type: '021v01c01a01',
    imagePath: '/images2/021v01c01a01.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '27',
    id: '63',
    type: '021v01c01a02',
    imagePath: '/images2/021v01c01a02.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '28',
    id: '64',
    type: '021v01c01a03',
    imagePath: '/images2/021v01c01a03.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '29',
    id: '65',
    type: '021v01c01a04',
    imagePath: '/images2/021v01c01a04.png',
    colourType: '0',
    view: '1',
  },

  {
    groupid: '30',
    id: '66',
    type: '022v01c01a01',
    imagePath: '/images2/022v01c01a01.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '31',
    id: '67',
    type: '022v01c01a02',
    imagePath: '/images2/022v01c01a02.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '32',
    id: '68',
    type: '022v01c01a03',
    imagePath: '/images2/022v01c01a03.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '33',
    id: '69',
    type: '022v01c01a04',
    imagePath: '/images2/022v01c01a04.png',
    colourType: '0',
    view: '1',
  },

  {
    groupid: '34',
    id: '70',
    type: '030v01c01a01',
    imagePath: '/images2/030v01c01a01.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '35',
    id: '71',
    type: '030v01c01a02',
    imagePath: '/images2/030v01c01a02.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '37',
    id: '73',
    type: '030v01c01a04',
    imagePath: '/images2/030v01c01a04.png',
    colourType: '0',
    view: '1',
  },

  {
    groupid: '38',
    id: '74',
    type: '031v01c01a01',
    imagePath: '/images2/031v01c01a01.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '39',
    id: '75',
    type: '031v01c01a02',
    imagePath: '/images2/031v01c01a02.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '40',
    id: '76',
    type: '031v01c01a03',
    imagePath: '/images2/031v01c01a03.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '41',
    id: '77',
    type: '031v01c01a04',
    imagePath: '/images2/031v01c01a04.png',
    colourType: '0',
    view: '1',
  },

  {
    groupid: '42',
    id: '78',
    type: '032v01c01a01',
    imagePath: '/images2/032v01c01a01.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '43',
    id: '79',
    type: '032v01c01a02',
    imagePath: '/images2/032v01c01a02.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '44',
    id: '80',
    type: '032v01c01a03',
    imagePath: '/images2/032v01c01a03.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '45',
    id: '81',
    type: '032v01c01a04',
    imagePath: '/images2/032v01c01a04.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '46',
    id: '82',
    type: '040v01c01a01',
    imagePath: '/images2/040v01c01a01.png',
    colourType: '0',
    view: '1',
  },

  {
    groupid: '47',
    id: '83',
    type: '041v01c01a01',
    imagePath: '/images2/041v01c01a01.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '48',
    id: '84',
    type: '041v01c01a02',
    imagePath: '/images2/041v01c01a02.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '49',
    id: '85',
    type: '041v01c01a03',
    imagePath: '/images2/041v01c01a03.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '50',
    id: '86',
    type: '041v01c01a04',
    imagePath: '/images2/041v01c01a04.png',
    colourType: '0',
    view: '1',
  },

  {
    groupid: '51',
    id: '87',
    type: '042v01c01a01',
    imagePath: '/images2/042v01c01a01.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '52',
    id: '88',
    type: '042v01c01a02',
    imagePath: '/images2/042v01c01a02.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '53',
    id: '89',
    type: '042v01c01a03',
    imagePath: '/images2/042v01c01a03.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '54',
    id: '90',
    type: '042v01c01a04',
    imagePath: '/images2/042v01c01a04.png',
    colourType: '0',
    view: '1',
  },

  {
    groupid: '55',
    id: '91',
    type: '043v01c01a01',
    imagePath: '/images2/043v01c01a01.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '56',
    id: '92',
    type: '043v01c01a02',
    imagePath: '/images2/043v01c01a02.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '57',
    id: '93',
    type: '043v01c01a03',
    imagePath: '/images2/043v01c01a03.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '58',
    id: '94',
    type: '043v01c01a04',
    imagePath: '/images2/043v01c01a04.png',
    colourType: '0',
    view: '1',
  },

  {
    groupid: '59',
    id: '95',
    type: '044v01c01a01',
    imagePath: '/images2/044v01c01a01.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '60',
    id: '96',
    type: '044v01c01a02',
    imagePath: '/images2/044v01c01a02.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '61',
    id: '97',
    type: '044v01c01a03',
    imagePath: '/images2/044v01c01a03.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '62',
    id: '98',
    type: '044v01c01a04',
    imagePath: '/images2/044v01c01a04.png',
    colourType: '0',
    view: '1',
  },

  {
    groupid: '63',
    id: '101',
    type: '045v01c01a01',
    imagePath: '/images2/045v01c01a01.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '64',
    id: '102',
    type: '045v01c01a02',
    imagePath: '/images2/045v01c01a02.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '65',
    id: '103',
    type: '045v01c01a03',
    imagePath: '/images2/045v01c01a03.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '66',
    id: '104',
    type: '045v01c01a04',
    imagePath: '/images2/045v01c01a04.png',
    colourType: '0',
    view: '1',
  },

  {
    groupid: '67',
    id: '105',
    type: '046v01c01a01',
    imagePath: '/images2/046v01c01a01.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '68',
    id: '106',
    type: '046v01c01a02',
    imagePath: '/images2/046v01c01a02.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '69',
    id: '107',
    type: '046v01c01a03',
    imagePath: '/images2/046v01c01a03.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '70',
    id: '108',
    type: '046v01c01a04',
    imagePath: '/images2/046v01c01a04.png',
    colourType: '0',
    view: '1',
  },

  {
    groupid: '71',
    id: '109',
    type: '050v01c01a01',
    imagePath: '/images2/050v01c01a01.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '71',
    id: '110',
    type: '050v01c02a01',
    imagePath: '/images2/050v01c02a01.png',
    colourType: '1',
    view: '0',
  },
  {
    groupid: '71',
    id: '111',
    type: '050v01c03a01',
    imagePath: '/images2/050v01c03a01.png',
    colourType: '2',
    view: '0',
  },

  {
    groupid: '72',
    id: '112',
    type: '060v01c01a01',
    imagePath: '/images2/060v01c01a01.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '72',
    id: '113',
    type: '060v01c02a01',
    imagePath: '/images2/060v01c02a01.png',
    colourType: '1',
    view: '0',
  },
  {
    groupid: '72',
    id: '114',
    type: '060v01c03a01',
    imagePath: '/images2/060v01c03a01.png',
    colourType: '2',
    view: '0',
  },

  {
    groupid: '73',
    id: '115',
    type: '060v02c01a01',
    imagePath: '/images2/060v02c01a01.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '73',
    id: '116',
    type: '060v02c02a01',
    imagePath: '/images2/060v02c02a01.png',
    colourType: '1',
    view: '0',
  },
  {
    groupid: '73',
    id: '117',
    type: '060v02c03a01',
    imagePath: '/images2/060v02c03a01.png',
    colourType: '2',
    view: '0',
  },

  {
    groupid: '74',
    id: '118',
    type: '090v01c01a01',
    imagePath: '/images2/090v01c01a01.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '75',
    id: '119',
    type: '091v01c01a01',
    imagePath: '/images2/091v01c01a01.png',
    colourType: '0',
    view: '1',
  },

  {
    groupid: '76',
    id: '120',
    type: '100v01c01a01',
    imagePath: '/images2/100v01c01a01.png',
    colourType: '0',
    view: '1',
  },

  {
    groupid: '78',
    id: '122',
    type: '101v01c01a01',
    imagePath: '/images2/101v01c01a01.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '83',
    id: '100',
    type: 'Display Text',
    imagePath:
      'data:image/svg+xml;charset=UTF-8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 96" fill="none" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="8" y="8" width="80" height="80" rx="0" ry="0" fill="none" stroke="black" stroke-width="2"/></svg>',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '84',
    id: '200', // ✅ Text Box ID: 200
    type: 'Text Box',
    // imagePath: generateTextBoxSVG('Örnek Yazı'),
    imagePath:
      'data:image/svg+xml;charset=UTF-8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 96" fill="none" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="8" y="8" width="80" height="80" rx="0" ry="0" fill="none" stroke="black" stroke-width="2"/></svg>',
    colourType: '0',
    view: '1',
  },

  {
    groupid: '80',
    id: '124',
    type: '102v01c01a01',
    imagePath: '/images2/102v01c01a01.png',
    colourType: '0',
    view: '1',
  },

  {
    groupid: '81',
    id: '125',
    type: '102v01c02a01',
    imagePath: '/images2/102v01c02a01.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '82',
    id: '126',
    type: '102v01c03a01',
    imagePath: '/images2/102v01c03a01.png',
    colourType: '0',
    view: '1',
  },

  {
    groupid: '78',
    id: '123',
    type: '101v01c02a01',
    imagePath: '/images2/101v01c02a01.png',
    colourType: '1',
    view: '0',
  },
  {
    groupid: '76',
    id: '121',
    type: '100v01c02a01',
    imagePath: '/images2/100v01c02a01.png',
    colourType: '1',
    view: '0',
  },
  {
    groupid: '999',
    id: '9999',
    type: 'Flow Link Button',
    imagePath:
      "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='80'><rect width='200' height='80' rx='10' ry='10' fill='%23007BFF' /></svg>",
    colourType: '0',
    view: '1',
    isFlowLinkButton: true,
  },

  {
    groupid: '120',
    id: '131',
    type: '012v01c02a01',
    imagePath: '/images2/012v01c02a01.png',
    colourType: '1',
    view: '0',
  },
  {
    groupid: '120',
    id: '132',
    type: '012v01c03a01',
    imagePath: '/images2/012v01c03a01.png',
    colourType: '2',
    view: '0',
  },
  {
    groupid: '120',
    id: '130',
    type: '012v01c04a01',
    imagePath: '/images2/012v01c04a01.png',
    colourType: '3',
    view: '1',
  },

  {
    groupid: '120',
    id: '134',
    type: '012v01c05a01',
    imagePath: '/images2/012v01c05a01.png',
    colourType: '4',
    view: '0',
  },

  {
    groupid: '121',
    id: '136',
    type: '012v01c02a02',
    imagePath: '/images2/012v01c02a02.png',
    colourType: '1',
    view: '0',
  },
  {
    groupid: '121',
    id: '137',
    type: '012v01c03a02',
    imagePath: '/images2/012v01c03a02.png',
    colourType: '2',
    view: '0',
  },
  {
    groupid: '121',
    id: '135',
    type: '012v01c04a02',
    imagePath: '/images2/012v01c04a02.png',
    colourType: '3',
    view: '1',
  },
  {
    groupid: '121',
    id: '139',
    type: '012v01c05a02',
    imagePath: '/images2/012v01c05a02.png',
    colourType: '4',
    view: '0',
  },

  {
    groupid: '122',
    id: '141',
    type: '012v01c02a03',
    imagePath: '/images2/012v01c02a03.png',
    colourType: '1',
    view: '0',
  },
  {
    groupid: '122',
    id: '142',
    type: '012v01c03a03',
    imagePath: '/images2/012v01c03a03.png',
    colourType: '2',
    view: '0',
  },
  {
    groupid: '122',
    id: '140',
    type: '012v01c04a03',
    imagePath: '/images2/012v01c04a03.png',
    colourType: '3',
    view: '1',
  },

  {
    groupid: '122',
    id: '144',
    type: '012v01c05a03',
    imagePath: '/images2/012v01c05a03.png',
    colourType: '4',
    view: '0',
  },

  {
    groupid: '123',
    id: '146',
    type: '012v01c02a04',
    imagePath: '/images2/012v01c02a04.png',
    colourType: '1',
    view: '0',
  },
  {
    groupid: '123',
    id: '147',
    type: '012v01c03a04',
    imagePath: '/images2/012v01c03a04.png',
    colourType: '2',
    view: '0',
  },
  {
    groupid: '123',
    id: '145',
    type: '012v01c04a04',
    imagePath: '/images2/012v01c04a04.png',
    colourType: '3',
    view: '1',
  },
  {
    groupid: '123',
    id: '149',
    type: '012v01c05a04',
    imagePath: '/images2/012v01c05a04.png',
    colourType: '4',
    view: '0',
  },
  {
    groupid: '124',
    id: '150',
    type: '092v01c01a01',
    imagePath: '/images2/092v01c01a01.png',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '125',
    id: '151',
    type: '093v01c01a01',
    imagePath: '/images2/093v01c01a01.png',
    colourType: '0',
    view: '1',
  },

  {
    groupid: '126',
    id: '152',
    type: '103v01c01a01',
    imagePath: '/images2/103v01c01a01.svg',
    colourType: '0',
    view: '1',
  },
  {
    groupid: '126',
    id: '153',
    type: '103v01c02a01',
    imagePath: '/images2/103v01c02a01.svg',
    colourType: '1',
    view: '0',
  },

  {
    id: '300',
    name: 'Alarms',
    type: 'AlarmsView',
    imagePath: '/images/alarm.png',
    view: '1',
    groupid: '3',
    colourType: '0',
  },
  //new
  {
    groupid: '128',
    id: '154',
    type: '010v01c02a01',
    imagePath: '/images2/010v01c02a01.png',
    colourType: '1',
    view: '0',
  },
  {
    groupid: '128',
    id: '155',
    type: '010v01c03a01',
    imagePath: '/images2/010v01c03a01.png',
    colourType: '2',
    view: '0',
  },
  {
    groupid: '128',
    id: '156',
    type: '010v01c04a01',
    imagePath: '/images2/010v01c04a01.png',
    colourType: '3',
    view: '1',
  },
  {
    groupid: '128',
    id: '157',
    type: '010v01c05a01',
    imagePath: '/images2/010v01c05a01.png',
    colourType: '4',
    view: '0',
  },
  {
    groupid: '129',
    id: '158',
    type: '010v01c02a02',
    imagePath: '/images2/010v01c02a02.png',
    colourType: '1',
    view: '0',
  },
  {
    groupid: '129',
    id: '159',
    type: '010v01c03a02',
    imagePath: '/images2/010v01c03a02.png',
    colourType: '2',
    view: '0',
  },
  {
    groupid: '129',
    id: '160',
    type: '010v01c04a02',
    imagePath: '/images2/010v01c04a02.png',
    colourType: '3',
    view: '1',
  },
  {
    groupid: '129',
    id: '161',
    type: '010v01c05a02',
    imagePath: '/images2/010v01c05a02.png',
    colourType: '4',
    view: '0',
  },

  {
    groupid: '130',
    id: '162',
    type: '010v01c02a03',
    imagePath: '/images2/010v01c02a03.png',
    colourType: '1',
    view: '0',
  },
  {
    groupid: '130',
    id: '163',
    type: '010v01c03a03',
    imagePath: '/images2/010v01c03a03.png',
    colourType: '2',
    view: '0',
  },
  {
    groupid: '130',
    id: '164',
    type: '010v01c04a03',
    imagePath: '/images2/010v01c04a03.png',
    colourType: '3',
    view: '1',
  },
  {
    groupid: '130',
    id: '165',
    type: '010v01c05a03',
    imagePath: '/images2/010v01c05a03.png',
    colourType: '4',
    view: '0',
  },
  {
    groupid: '131',
    id: '166',
    type: '010v01c02a04',
    imagePath: '/images2/010v01c02a04.png',
    colourType: '1',
    view: '0',
  },
  {
    groupid: '131',
    id: '167',
    type: '010v01c03a04',
    imagePath: '/images2/010v01c03a04.png',
    colourType: '2',
    view: '0',
  },
  {
    groupid: '131',
    id: '168',
    type: '010v01c04a04',
    imagePath: '/images2/010v01c04a04.png',
    colourType: '3',
    view: '1',
  },
  {
    groupid: '131',
    id: '169',
    type: '010v01c05a04',
    imagePath: '/images2/010v01c05a04.png',
    colourType: '4',
    view: '0',
  },

  {
    groupid: '132',
    id: '170',
    type: '011v01c02a01',
    imagePath: '/images2/011v01c02a01.png',
    colourType: '1',
    view: '0',
  },
  {
    groupid: '132',
    id: '171',
    type: '011v01c02a01',
    imagePath: '/images2/011v01c02a01.png',
    colourType: '2',
    view: '0',
  },
  {
    groupid: '132',
    id: '172',
    type: '011v01c04a01',
    imagePath: '/images2/011v01c04a01.png',
    colourType: '3',
    view: '1',
  },
  {
    groupid: '132',
    id: '173',
    type: '011v01c05a01',
    imagePath: '/images2/011v01c05a01.png',
    colourType: '4',
    view: '0',
  },

  {
    groupid: '133',
    id: '174',
    type: '011v01c02a02',
    imagePath: '/images2/011v01c02a02.png',
    colourType: '1',
    view: '0',
  },
  {
    groupid: '133',
    id: '175',
    type: '011v01c02a02',
    imagePath: '/images2/011v01c02a02.png',
    colourType: '2',
    view: '0',
  },
  {
    groupid: '133',
    id: '176',
    type: '011v01c04a02',
    imagePath: '/images2/011v01c04a02.png',
    colourType: '3',
    view: '1',
  },
  {
    groupid: '133',
    id: '177',
    type: '011v01c05a02',
    imagePath: '/images2/011v01c05a02.png',
    colourType: '4',
    view: '0',
  },

  {
    groupid: '134',
    id: '178',
    type: '011v01c02a03',
    imagePath: '/images2/011v01c02a03.png',
    colourType: '1',
    view: '0',
  },
  {
    groupid: '134',
    id: '179',
    type: '011v01c02a03',
    imagePath: '/images2/011v01c02a03.png',
    colourType: '2',
    view: '0',
  },
  {
    groupid: '134',
    id: '180',
    type: '011v01c04a03',
    imagePath: '/images2/011v01c04a03.png',
    colourType: '3',
    view: '1',
  },
  {
    groupid: '134',
    id: '181',
    type: '011v01c05a03',
    imagePath: '/images2/011v01c05a03.png',
    colourType: '4',
    view: '0',
  },

  {
    groupid: '135',
    id: '182',
    type: '011v01c02a04',
    imagePath: '/images2/011v01c02a04.png',
    colourType: '1',
    view: '0',
  },
  {
    groupid: '135',
    id: '183',
    type: '011v01c02a04',
    imagePath: '/images2/011v01c02a04.png',
    colourType: '2',
    view: '0',
  },
  {
    groupid: '135',
    id: '184',
    type: '011v01c04a04',
    imagePath: '/images2/011v01c04a04.png',
    colourType: '3',
    view: '1',
  },
  {
    groupid: '135',
    id: '185',
    type: '011v01c05a04',
    imagePath: '/images2/011v01c05a04.png',
    colourType: '4',
    view: '0',
  },
  // // Range-based components (minValue/maxValue)
  // {
  //   groupid: '137',
  //   id: '187',
  //   type: 'gd2g_on',
  //   imagePath: '/images2/GDSFX_Green.png',
  //   colourType: '0',
  //   minValue: 30,
  //   maxValue: 70.99,
  //   view: '1',
  // },
  // {
  //   groupid: '137',
  //   id: '188',
  //   type: 'gd2g_on',
  //   imagePath: '/images2/GDSFX_Yellow.png',
  //   colourType: '1',
  //   minValue: 71,
  //   maxValue: 150.99,
  //   view: '0',
  // },
  // {
  //   groupid: '137',
  //   id: '189',
  //   type: 'gd2g_on',
  //   imagePath: '/images2/GDSFX_Red.png',
  //   colourType: '2',
  //   minValue: 151,
  //   maxValue: 9999,
  //   view: '0',
  // },
  {
    groupid: '138',
    id: '190',
    type: 'GDMP',
    imagePath: '/images2/GDMP.svg',
    colourType: '1',
    view: '1',
  },
  {
    groupid: '139',
    id: '191',
    type: 'GD2G',
    imagePath: '/images2/gd2g_gray.svg',
    colourType: '1',
    view: '1',
  },
  {
    groupid: '140',
    id: '192',
    type: 'GD2G',
    imagePath: '/images2/gd2g_blue.svg',
    colourType: '1',
    view: '1',
  },
  {
    groupid: '141',
    id: '193',
    type: 'GD2G',
    imagePath: '/images2/gd2g_yellow.svg',
    colourType: '1',
    view: '1',
  },
  {
    groupid: '142',
    id: '194',
    type: 'GDSFX',
    imagePath: '/images2/gdsfx_red.svg',
    colourType: '1',
    view: '0',
  }, // 1,0 → kırmızı
  {
    groupid: '142',
    id: '195',
    type: 'GDSFX',
    imagePath: '/images2/gdsfx_yellow.svg',
    colourType: '2',
    view: '0',
  }, // 0,1 → sarı
  {
    groupid: '142',
    id: '196',
    type: 'GDSFX',
    imagePath: '/images2/gdsfx_green.svg',
    colourType: '3',
    view: '1',
  }, // 0,0 → yeşil (palette default)
  {
    groupid: '142',
    id: '197',
    type: 'GDSFX',
    imagePath: '/images2/gdsfx_red.svg',
    colourType: '4',
    view: '0',
  }, // 1,1 → kırmızı
  {
    groupid: '143',
    id: '210',
    type: 'GD',
    imagePath: '/images2/gdsfx_green.svg',
    colourType: '0', //tag değeri 0 ise yeşil
    view: '1'
  },
  {
    groupid: '143',
    id: '211',
    type: 'GD',
    imagePath: '/images2/gdsfx_yellow.svg',
    colourType: '1', //tag değeri 1 ise sarı
    view: '0'
  },
  {
    groupid: '143',
    id: '212',
    type: 'GD',
    imagePath: '/images2/gdsfx_red.svg',
    colourType: '2', //tag değeri 2 ise kırmızı
    view: '0'
  },

  {
    groupid: '144',
    id: '213',
    type: 'GD STATUS',
    imagePath: '/images2/103v01c02a01.svg',
    colourType: '0', //tag değeri 0 ise yeşil
    view: '1'
  },
  {
    groupid: '144',
    id: '214',
    type: 'GD STATUS',
    imagePath: '/images2/103v01c03a01.svg',
    colourType: '1', //tag değeri 1 ise sarı
    view: '0'
  },
  {
    groupid: '144',
    id: '215',
    type: 'GD STATUS',
    imagePath: '/images2/103v01c01a01.svg',
    colourType: '2', //tag değeri 2 ise kırmızı
    view: '0'
  },
  {
    groupid: '144',
    id: '216',
    type: 'GD STATUS',
    imagePath: '/images2/103v01c01a01.svg',
    colourType: '3', //tag değeri 3 ise kırmızı
    view: '0'
  },

  {
    groupid: '145',
    id: '217',
    type: 'FAULT STATUS',
    imagePath: '/images2/103v01c02a01.svg',
    colourType: '0', //tag değeri 0 ise yeşil
    view: '1'
  },
  {
    groupid: '145',
    id: '218',
    type: 'FAULT STATUS',
    imagePath: '/images2/103v01c01a01.svg',
    colourType: '1', //tag değeri 1 ise kırmızı
    view: '0'
  },
  {
    groupid: '143',
    id: '219',
    type: 'GD',
    imagePath: '/images2/gdsfx_red.svg',
    colourType: '2', //tag değeri 2 ise kırmızı
    view: '0'
  },

  ...industrialToolboxItems,
  ...sectorIconItems,
  ...connectorToolboxItems,
  ...gapFillToolboxItems,
];

// ============================================================================
// AÇI VARYANTI SADELEŞTİRME (Nexa-Flow 360° rotate)
// ============================================================================
// Mimic bileşenleri artık canvas üzerinde fare ile 360° döndürülebiliyor
// (FlowComponent.js > rotate handle). Bu yüzden "aynı bileşenin 90/180/270
// derece döndürülmüş kopyası" olan palette girdilerini ayrı ayrı listelemenin
// bir anlamı kalmadı — kullanıcı tek girdiyi sürükleyip istediği açıya
// çeviriyor.
//
// NEDEN SİLMİYORUZ, SADECE GİZLİYORUZ:
// Kayıtlı flow'lar (FlowItems.toolbox_id) bu id'lere referans veriyor. Girdi
// silinirse eski ekranlarda bileşen "default.png"e düşer. Bu yüzden girdiler
// dizide KALIYOR, sadece view:'0' yapılıyor:
//   - view:'0' => palette'te (sürükle-bırak listesinde) görünmez,
//   - getImagePathByToolboxId() hâlâ id/groupid üzerinden doğru görseli bulur
//     (grup içinde view:'1' yoksa groupItems[0]'a düşüyor),
// yani eski ekranlar birebir aynı görünmeye devam eder.
//
// Eşleşmeler `magick compare -metric RMSE` ile doğrulandı: her gizlenen
// görsel, karşısındaki temel görselin tam olarak 90/180/270° döndürülmüş
// hâli (RMSE ~0).
//
// images2 varlıkları `NNNvVVcCCaAA.png` şemasını kullanıyor; `aAA` = açı
// (a01=0°, a02=90°, a03=180°, a04=270°). Aşağıdaki tablo "gizlenecek id" ->
// "yerine kalan temel id" eşlemesidir.
const ROTATED_DUPLICATE_OF = {
  // 001v01 — düz boru
  '2': '1',
  // 002v01 — dirsek
  '4': '3', '5': '3', '6': '3',
  // 003v01 — T bağlantı
  '8': '7', '9': '7', '10': '7',
  // 005v01 / 006v01 — düz boru (alternatif renk)
  '202': '201',
  '204': '203',
  // 010v01 — tek register varyantı (c01) ve iki-bit varyantı (c04)
  '16': '12', '20': '12', '24': '12',
  '160': '156', '164': '156', '168': '156',
  // 011v01
  '32': '28', '36': '28', '40': '28',
  '176': '172', '180': '172', '184': '172',
  // 012v01
  '48': '44', '52': '44', '56': '44',
  '135': '130', '140': '130', '145': '130',
  // 020v01 / 021v01 / 022v01
  '61': '60',
  '63': '62', '64': '62', '65': '62',
  '67': '66', '68': '66', '69': '66',
  // 030v01 (a03 zaten yok) / 031v01 / 032v01
  '71': '70', '73': '70',
  '75': '74', '76': '74', '77': '74',
  '79': '78', '80': '78', '81': '78',
  // 041v01 .. 046v01
  '84': '83', '85': '83', '86': '83',
  '88': '87', '89': '87', '90': '87',
  '92': '91', '93': '91', '94': '91',
  '96': '95', '97': '95', '98': '95',
  '102': '101', '103': '101', '104': '101',
  '106': '105', '107': '105', '108': '105',
  // industrialToolboxItems — v_hor / v_ver1 / v_ver2 aynı vananın 0°/90°/270°
  // hâlleri (grup 506 / 507 / 508). Temel olan yatay hâli tutuluyor.
  '520': '517', // Vertical Control Valve   = Control Valve @90°
  '523': '517', // Vertical Isolation Valve = Control Valve @270°
  // connectorToolboxItems — Line/Arrow artık tek girdi, diğer yönler
  // connectorPreview(kind, angle) ile üretilen aynı şeklin döndürülmüş hâli
  // (RMSE değil, SVG kaynağı zaten paylaşılan fonksiyon — birebir aynı).
  '801': '800', // Line (Vertical)  = Line @90°
  '803': '802', // Arrow (Left)     = Arrow @180°
  '804': '802', // Arrow (Up)       = Arrow @270°
  '805': '802', // Arrow (Down)     = Arrow @90°
};

export const toolboxItems = baseToolboxItems.map(item =>
  ROTATED_DUPLICATE_OF[item.id]
    ? { ...item, view: '0', rotatedDuplicateOf: ROTATED_DUPLICATE_OF[item.id] }
    : item
);
